(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/toplists/receiver-toplists-most-popular-points.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/toplists/receiver-toplists-most-popular-points.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.receiver_toplists_most_popular_points = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"grassroots-get-more-receivers padding-xs-1\">\n    "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"class":"js-fetch-more js-fetch-more-most-popular-points","block":true,"transparent":true,"size":300},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":130}}})) != null ? stack1 : "")
    + "\n  </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "Hämta fler";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-receiver-toplists-most-popular-points\"></div>\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"offsetPoints") : depth0),"<","45",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":6,"column":12}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['svs-grassroots_shared-receiver_toplists_most_popular_points'] = svs.grassroots_shared.templates.receiver_toplists_most_popular_points;
})(svs, Handlebars);


 })(window);